// Screenname:DeliveryTerms master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages:
import httpbaseURL from "../../../../modules/Inventory/common/axios";
class AssetMasterServices {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AssetMaster/CreateCustom",
      doc
    );
  }
  getdata() {
    return httpbaseURL.httpMSInventoryUrl.get("/AssetMaster/List");
  }
  getfindonedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.get("/Common/GetByAssetId?id=" + doc);
  }

  getAssetByGRNId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaster/GetAssetByGRNId?GRNId=" + doc
    );
  }

  listAssetByItemId(doc, GRNId, HId, BId, SId, SInDId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaster/ListAssetByItemId?ItemId=" +
        doc +
        "&GRNId=" +
        GRNId +
        "&HospitalId=" +
        HId +
        "&BranchId=" +
        BId +
        "&StoreId=" +
        SId +
        "&StockInDetailId=" +
        SInDId
    );
  }
  //asset details fetch
  getItemDetailsByAssetId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaster/GetItemDetailsByAssetId?AssetId=" + doc
    );
  }

  getByAssetIdDetails(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaster/GetByAssetIdDetails?id=" + doc
    );
  }

  getAssetIdbyAutoComplete(AsId, HId, BId, SId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaster/AssetIdAutocompleteList?assetDisplayId=" +
        AsId +
        "&HospitalId=" +
        HId +
        "&BranchId=" +
        BId +
        "&StoreId=" +
        SId
    );
  }
  getAssetIdbyAutoCompleteAssignList(AsId, HId, BId, SId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaster/AssetIdAutocompleteAssignList?AssetDisplayId=" +
        AsId +
        "&HospitalId=" +
        HId +
        "&BranchId=" +
        BId +
        "&StoreId=" +
        SId
    );
  }

  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AssetMaster/Update", doc);
  }
  deletedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/AssetMaster/Delete?id=" + doc
    );
  }
  active(DelID, Status) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.put(
      "AssetMaster/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
  getListAssetDashBoard(HId, BId, SId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaster/ListAssetDashBoard?HospitalId=" +
        HId +
        "&BranchId=" +
        BId +
        "&StoreId=" +
        SId
    );
  }
  getListAssetDashBoardDetails(HId, BId, SId, flag) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaster/ListAssetDashBoardDetails?HospitalId=" +
        HId +
        "&BranchId=" +
        BId +
        "&StoreId=" +
        SId +
        "&flag=" +
        flag
    );
  }
}
export default new AssetMasterServices();
